function patchJudgeMeForDrawer() {
  if (typeof jdgm === 'undefined' || jdgm.__drawerPatchApplied) return;
  if (typeof jdgm.initializeWidgets !== 'function') return;

  jdgm.__drawerPatchApplied = true;

  const originalInit = jdgm.initializeWidgets.bind(jdgm);
  jdgm.initializeWidgets = function (container) {
    const $ = jdgm.$;
    const $scope = container ? $(container) : $(document.body);

    $scope.find('.jdgm-review-widget[data-jdgm-drawer-widget]').each(function () {
      $(this).addClass(jdgm.DONE_SETUP_WIDGET_CLASS);
    });

    return originalInit(container);
  };
}

patchJudgeMeForDrawer();
document.addEventListener('DOMContentLoaded', patchJudgeMeForDrawer);
window.patchJudgeMeForDrawer = patchJudgeMeForDrawer;

class ProductInfoDrawer extends HTMLElement {
  constructor() {
    super();

    this.activeElement = null;
    this.reviewsLoaded = false;
    this.reviewsLoading = false;

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    this.querySelectorAll('[data-drawer-tab]').forEach((tab) => {
      tab.addEventListener('click', () => this.activateTab(tab.dataset.drawerTab));
    });
  }

  connectedCallback() {
    patchJudgeMeForDrawer();
    this.markDrawerJudgeMeWidget();
    this.bindExternalLinks();
    this.bindCloseHandlers();
    this.bindCrossSellWishlist();

    if (typeof CartCrossSell !== 'undefined') {
      CartCrossSell.preloadProductDrawerCrossSell(this);
    }
  }

  bindCrossSellWishlist() {
    const crossSell = this.querySelector('.cart-cross-sell--product-drawer');
    if (!crossSell || crossSell.dataset.wishlistBound === 'true') return;

    crossSell.dataset.wishlistBound = 'true';
    crossSell.addEventListener('cross-sell:loaded', () => this.initSwymButtons());
  }

  initSwymButtons() {
    const crossSell = this.querySelector('.cart-cross-sell--product-drawer');
    if (!crossSell || !window._swat?.initializeActionButtons) return;
    window._swat.initializeActionButtons(crossSell);
  }

  bindCloseHandlers() {
    if (this.dataset.closeHandlersBound === 'true') return;

    this.dataset.closeHandlersBound = 'true';

    this.querySelector('[data-drawer-close]')?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (!this.classList.contains('active')) return;

      const inner = this.querySelector('.product-info-drawer__inner');
      if (inner && !inner.contains(event.target)) {
        this.close();
      }
    });
  }

  markDrawerJudgeMeWidget() {
    this.querySelectorAll('.jdgm-review-widget').forEach((widget) => {
      widget.dataset.jdgmDrawerWidget = 'true';

      if (typeof jdgm !== 'undefined' && jdgm.DONE_SETUP_WIDGET_CLASS) {
        widget.classList.add(jdgm.DONE_SETUP_WIDGET_CLASS);
      }
    });
  }

  bindExternalLinks() {
    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    document
      .querySelectorAll(`[data-product-info-trigger="${sectionId}"]:not([data-drawer-bound])`)
      .forEach((trigger) => {
        trigger.dataset.drawerBound = 'true';
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(trigger, trigger.dataset.tabId);
        });
      });
  }

  open(triggeredBy, tabId) {
    if (triggeredBy) this.activeElement = triggeredBy;

    setTimeout(() => {
      this.classList.add('animate', 'active');

      if (typeof CartCrossSell !== 'undefined') {
        CartCrossSell.scheduleInit();
        this.initSwymButtons();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const focusElement = this.querySelector('.product-info-drawer__close') || this.querySelector('.drawer__inner');
        trapFocus(this.querySelector('.drawer__inner'), focusElement);
      },
      { once: true }
    );

    lockBodyScroll();

    const initialTab = tabId || this.querySelector('[data-drawer-tab]')?.dataset.drawerTab;
    if (initialTab) this.activateTab(initialTab);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    unlockBodyScroll();
  }

  activateTab(tabId) {
    if (!tabId) return;

    this.querySelectorAll('[data-drawer-tab]').forEach((tab) => {
      const isActive = tab.dataset.drawerTab === tabId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.querySelectorAll('[data-drawer-panel]').forEach((panel) => {
      const isActive = panel.dataset.drawerPanel === tabId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    document.querySelectorAll(`[data-product-info-trigger="${this.dataset.sectionId}"]`).forEach((trigger) => {
      trigger.classList.toggle('is-active', trigger.dataset.tabId === tabId);
    });

    if (tabId === 'reviews') this.loadReviews();

    if (typeof window.initProductSizeGuides === 'function') {
      window.initProductSizeGuides(this);
    }

    const scrollContainer = this.querySelector('.product-info-drawer__content');
    if (scrollContainer) scrollContainer.scrollTop = 0;
  }

  ensureWriteReviewButton($widget) {
    const $ = jdgm.$;
    let $link = $widget.find('.jdgm-write-rev-link, .jdgm-write-rev-btn').first();

    if (!$link.length && typeof jdgm._renderAndSetupReviewForm === 'function') {
      jdgm._renderAndSetupReviewForm($widget);
      $link = $widget.find('.jdgm-write-rev-link, .jdgm-write-rev-btn').first();
    }

    if (!$link.length) return;

    let $actions = $widget.find('.jdgm-widget-actions-wrapper, .jdgm-rev-widg__actions').first();

    if (!$actions.length && typeof jdgm._widgetActionsWrapper === 'function') {
      $actions = $(jdgm._widgetActionsWrapper(false));

      if (jdgm.isVersion3) {
        const $rowStars = $widget.find('.jdgm-row-stars').first();
        if ($rowStars.length) {
          $rowStars.append($actions);
        } else {
          $widget.find('.jdgm-rev-widg__header').append($actions);
        }
      } else {
        $widget.find('.jdgm-rev-widg__summary').after($actions);
      }
    }

    if ($actions.length && !$actions.find('.jdgm-write-rev-link, .jdgm-write-rev-btn').length) {
      $actions.append($link.detach());
    } else if (!$link.parent().length) {
      $widget.find('.jdgm-rev-widg__header').append($link);
    }

    $link.removeClass('jdgm-hidden').css('display', '');
  }

  initializeJudgeMe(container) {
    const init = () => {
      if (typeof jdgm === 'undefined' || typeof jdgm.$ !== 'function') return false;

      const $ = jdgm.$;
      const $container = $(container);
      const $widget = $container.find('.jdgm-review-widget');

      if (!$widget.length) return false;

      const $widgetEl = $widget.first();
      const hasRenderedWidget = $widgetEl.find('.jdgm-rev-widg').length > 0;

      $container.find('.jdgm-rev, .jdgm-quest, .jdgm-ans').removeClass(jdgm.DONE_SETUP_CLASS);

      if (hasRenderedWidget) {
        // Metafield HTML is already rendered server-side. Running _customizeReviewWidget
        // again duplicates the summary text and histogram bars.
        if (typeof jdgm._renderAndSetupReviewForm === 'function') {
          jdgm._renderAndSetupReviewForm($widgetEl);
        }
        if (typeof jdgm._setupQuestionsForm === 'function') {
          jdgm._setupQuestionsForm($widgetEl);
        }
        if (typeof jdgm._setupLoadReviewsEventsFor === 'function') {
          jdgm._setupLoadReviewsEventsFor($widgetEl);
        }
        if (typeof jdgm._setupFormsSubmit === 'function') {
          jdgm._setupFormsSubmit($widgetEl);
        }
        if (typeof jdgm.setupMediaGallery === 'function') {
          jdgm.setupMediaGallery($widgetEl);
        }

        this.ensureWriteReviewButton($widgetEl);
      } else if (typeof jdgm.initializeWidgets === 'function') {
        $widgetEl.removeClass(jdgm.DONE_SETUP_WIDGET_CLASS);
        jdgm.initializeWidgets($container);
      }

      if (typeof jdgm.customizeReviews === 'function') {
        jdgm.customizeReviews();
      }

      if (typeof jdgm.customizeTimestamp === 'function') {
        jdgm.customizeTimestamp($container);
      }

      $widgetEl.addClass(jdgm.DONE_SETUP_WIDGET_CLASS);

      if (jdgm.caches) {
        jdgm.caches.$widgetWithReviews = $('.jdgm-review-widget, .jdgm-revs-tab, .jdgm-all-reviews-widget');
        jdgm.caches.$revWidgets = $('.jdgm-review-widget');
      }

      return true;
    };

    if (init()) return;

    let attempts = 0;
    const retry = window.setInterval(() => {
      attempts += 1;
      if (init() || attempts >= 15) {
        window.clearInterval(retry);
      }
    }, 200);
  }

  loadReviews() {
    if (this.reviewsLoaded || this.reviewsLoading) return;

    const container = this.querySelector('[data-reviews-container]');
    if (!container) return;

    const widget = container.querySelector('.jdgm-review-widget');
    if (!widget) {
      if (!container.textContent.trim()) {
        container.innerHTML = '<p class="product-info-drawer__empty">Reviews are unavailable right now.</p>';
      }
      this.reviewsLoaded = true;
      return;
    }

    this.reviewsLoading = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.initializeJudgeMe(container);
        this.reviewsLoaded = true;
        this.reviewsLoading = false;
      });
    });
  }
}

if (!customElements.get('product-info-drawer')) {
  customElements.define('product-info-drawer', ProductInfoDrawer);
}
